import type RetsListing from '@bb/domain/dist/types/RetsListing';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const findLatestRetsListingByMlsNumber = async ({
  boardId,
  mlsNumber,
}: {
  boardId?: string;
  mlsNumber: string;
}) => {
  const searchParams = new URLSearchParams({
    ...(boardId && { boardId }),
    mlsNumber,
  });
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `/rets/listing/number?${searchParams.toString()}`,
  };

  const { data } = await axios.request<RetsListing>(config);

  return data;
};

export default findLatestRetsListingByMlsNumber;
